const duplicateExists = arr => {
  // Check if duplicates exist in array
  return new Set(arr).size !== arr.length;
};

export default duplicateExists;
